import { Component } from '@angular/core';

@Component({
  selector: 'skeleton-estadisticas-categorias',
  templateUrl: 'skeleton-estadisticas-categorias.html'
})
export class SkeletonEstadisticasCategoriasComponent {

  constructor() {

  }

}



// WEBPACK FOOTER //
// ./src/components/skeleton-estadisticas-categorias/skeleton-estadisticas-categorias.ts